import { Link } from 'react-router'
import { Eyebrow, Heading } from '#app/components/brand/section.tsx'
import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'
import { Footer } from './footer'
import Header from './header'

/**
 * Error boundary for marketing routes: keeps the brand chrome (header/footer)
 * and shows a calm, on-brand message instead of a bare alert.
 */
export function MarketingErrorBoundary({
	notFoundTitle = 'We couldn’t find that page',
	notFoundBody = 'The link may be old or mistyped. Everything else is still here.',
}: {
	notFoundTitle?: string
	notFoundBody?: string
}) {
	return (
		<div className="bg-canvas text-ink flex min-h-screen flex-col font-sans">
			<Header />
			<main className="mx-auto flex w-full max-w-[720px] flex-1 flex-col justify-center px-8 py-24 text-center">
				<GeneralErrorBoundary
					statusHandlers={{
						404: () => (
							<div>
								<Eyebrow className="mb-4 justify-center">404</Eyebrow>
								<Heading
									as="h1"
									className="text-[clamp(30px,5vw,44px)] leading-[1.06]"
								>
									{notFoundTitle}
								</Heading>
								<p className="mx-auto mt-4 max-w-[440px] text-lg text-pretty text-[#57565E]">
									{notFoundBody}
								</p>
								<Link
									to="/"
									className="text-brand mt-8 inline-block text-[15px] font-semibold"
								>
									← Back to home
								</Link>
							</div>
						),
					}}
				/>
			</main>
			<Footer />
		</div>
	)
}
